import { render, staticRenderFns } from "./FileTagManagerWidget.vue?vue&type=template&id=6339e003"
import script from "./FileTagManagerWidget.vue?vue&type=script&lang=js"
export * from "./FileTagManagerWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports